import { useStoreActions } from "../../store/store-context";
import { PracticeManagement } from "../../types/api.model";
import PMSetupPage from "./PMSetupPage/PMSetupPage";
import { jsx as _jsx } from "react/jsx-runtime";
export const KeeperSetupPage = _ref => {
  let {
    integration
  } = _ref;
  const {
    api,
    fetchKeeperItems
  } = useStoreActions();
  return /*#__PURE__*/_jsx(PMSetupPage, {
    testId: "keeper-setup",
    pmName: PracticeManagement.Keeper,
    integration: integration,
    getItems: fetchKeeperItems,
    doDisconnect: api.keeper.disconnect,
    linkServiceTemplate: api.keeper.linkServiceTemplate,
    getServiceTemplateIntegratedIds: template => template.integrations.keeperIntegratedIds()
  });
};